import { render } from "./RegistrationDocumentsListComponent.vue?vue&type=template&id=30434418"
import script from "./RegistrationDocumentsListComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationDocumentsListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__